import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CreateOrderDialog } from "@/components/orders/CreateOrderDialog";

export const QuoteOrderAction = ({ quote }) => {
  const { can } = useAuth();
  const [open, setOpen] = useState(false);
  const [orders, setOrders] = useState([]);
  useEffect(() => { if (can("ordini:read")) api.get("/orders", { params: { quote_id: quote.id } }).then((r) => setOrders(r.data.items)).catch(() => setOrders([])); }, [quote.id, can]);
  return (
    <>
      {orders.map((o) => <Button key={o.id} asChild variant="outline" size="sm"><Link to={`/ordini/${o.id}`} data-testid={`quote-order-link-${o.number}`}>{o.number}</Link></Button>)}
      {quote.status === "accettata" && can("ordini:create") && <Button className="gap-1" onClick={() => setOpen(true)} data-testid="quote-action-create-order"><ShoppingCart />Crea ordine da offerta accettata</Button>}
      <CreateOrderDialog open={open} onOpenChange={setOpen} quoteId={quote.id} />
    </>
  );
};
